<template>
  <el-container class="container">
    <el-header class="header">
      <Header />
    </el-header>
    <el-container class="content">
      <el-aside class="aside">
        <div class="toggle">
          <app-toggle />
        </div>
        <aside-menu class="menu" />
      </el-aside>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import appToggle from '@/components/main/app-toggle';
import Header from '@/components/main/header';
import asideMenu from '@/components/main/aside-menu';
export default {
  name: 'container',
  components: {
    appToggle,
    Header,
    asideMenu,
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.container {
  background-color: #f8f8f8;
  min-width: 1250px;
  height: 100vh;
  overflow-x: auto;
  overflow-y: auto;
  font-size: @base-font-size;
  .box_column_center();
  .header {
    z-index: 999;
    min-width: 100vw;
    padding: 0 !important;
    background-color: @bg-white;
    .box_row_column_center();
  }
  .content {
    width: 1250px;
    flex: 1;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    padding: 15px 0 20px 0;
    overflow-y: auto;
    .aside {
      width: @aside-width !important;
      .box_column();
      .menu {
        margin-top: 15px;
        flex: 1;
        overflow-y: auto;
      }
    }
  }
}
// 重写 element-UI 样式
.el-main {
  padding: 0 0 0 15px;
  overflow-y: auto;
}
</style>
